import { render, staticRenderFns } from "./diagnoses.vue?vue&type=template&id=14dd9346"
import script from "./diagnoses.vue?vue&type=script&lang=js"
export * from "./diagnoses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports